{"id":"LinkBox","prefabs":{"default":{"children":[{"component":"LinkBox","options":"options:*"}]}}}